export default function useDates() {
    function currentDate(){
        let day = new Date().getDate()
        let month = new Date().getMonth() + 1
        if(month < 10) month = '0' + month;
        if(day < 10) day = '0' + day;
        return new Date().getFullYear() + '-' + month + '-' + day
    }

    function startOfMonthDate(){
        let date = new Date(new Date().setMonth(new Date().getMonth())), month, year
        month = date.getMonth() + 1
        year = date.getFullYear()

        if(month < 10) month = '0' + month;
        return year + '-' + month + '-01'
    }

    function lastDayOfMonth() {
        let month = new Date().getMonth() + 1
        if(month < 10) month = '0' + month;
        let year = new Date().getFullYear()
        let last_day = new Date(year, month, 0).getDate()
        return year + '-' + month + '-' + last_day
    }

    function formatDate(date, config, local = 'en-GB') {
        const formatter = new Intl.DateTimeFormat(local, {...config});

        return formatter.format(new Date(date))
    }

    return {
        currentDate,
        startOfMonthDate,
        lastDayOfMonth,
        formatDate
    }
}